import { IKnmRejectReasonType } from 'APIPackage/CatalogsModule/interfaces/IKnmRejectReasonType';

import { IKnmRejectReasonTypeSelectOption } from '../interfaces/IKnmRejectReasonTypeSelectOption';

export const createKnmRejectReasonTypeSelectOption = (
  knmRejectReasonType: IKnmRejectReasonType,
): IKnmRejectReasonTypeSelectOption => ({
  ...knmRejectReasonType,
  label: knmRejectReasonType.name,
  value: knmRejectReasonType.code,
});
